import createVueApp from '../../shared/vue/create-app';
import initCustomControls from '../../components/custom-controls';
import {initCurrencyPriceComponents} from '../../components/inputs/currency-price';
import openPreviewMixin from '../../shared/vue/openPreviewMixin';
import initCustomInputsComponents from '../../components/inputs/custom-inputs';

const initServicePlansPage = (opts) => {
    const app = createVueApp({ // NOSONAR
        mixins: [openPreviewMixin],
        data() {
            return {
                featuredPeriod: 1,
                houseType: 1,
                offerType: 1,
                isBuyLocationMode: true,
            };
        },
        computed: {
        },
        methods: {
        },
    });

    initCustomControls(app);
    initCustomInputsComponents(app);
    initCurrencyPriceComponents(app);

    app.mount(opts.el);
};

export {initServicePlansPage};
